module.exports = __webpack_public_path__ + "static/media/UC.571e1ec4.svg";